export const baseURL = "https://ferrywheel.izoochat.com/";
export const adminBaseURL = "https://admin.izoochat.com/";
export const key = "3jx)61wjaez7uzvi_ol(jh(w^**cxbot@h*gj3m4b&&@2s%whw";